// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SmsRefillListResponse

import { hydrateSmsRefill, type SmsRefill, type SmsRefillApiResponse } from './smsRefill.gen';

export type SmsRefillListApiResponse = {
	items: SmsRefillApiResponse[];
};

export type SmsRefillList = {
	items: SmsRefill[];
};

export function hydrateSmsRefillList(data: SmsRefillListApiResponse): SmsRefillList {
	return {
		...data,
		items: data.items.map(hydrateSmsRefill),
	};
}